import PropTypes from 'prop-types';

var wizardStepShape = {
  title: PropTypes.string,
  render: PropTypes.func,
  onNext: PropTypes.func,
  isInvalid: PropTypes.bool,
  preventEnter: PropTypes.bool,
  preventExit: PropTypes.bool
};

export { wizardStepShape };


//////////////////
// WEBPACK FOOTER
// ./node_modules/patternfly-react/dist/esm/components/Wizard/Patterns/WizardPatternConstants.js
// module id = 185
// module chunks = 0